import React from "react";
import { Sparkles, Zap, Feather } from "lucide-react";

export const MODEL_OPTIONS = [
  { id: "claude",       label: "Claude",       hint: "atmospheric", Icon: Feather },
  { id: "gemini-pro",   label: "Gemini Pro",   hint: "depth",       Icon: Sparkles },
  { id: "gemini-flash", label: "Gemini Flash", hint: "fast",        Icon: Zap },
];

/** Compact segmented control to pick the LLM provider for a chat / story. */
export const ModelPicker = ({ value, onChange, className = "" }) => {
  return (
    <div
      data-testid="model-picker"
      role="radiogroup"
      className={`inline-flex items-center rounded-full border border-white/10 bg-[#07080A] p-0.5 ${className}`}
    >
      {MODEL_OPTIONS.map(({ id, label, hint, Icon }) => {
        const active = value === id;
        return (
          <button
            key={id}
            type="button"
            role="radio"
            aria-checked={active}
            data-testid={`model-pick-${id}`}
            onClick={() => onChange?.(id)}
            className={`inline-flex items-center gap-1.5 h-8 px-3 rounded-full font-mono text-[10px] uppercase tracking-widest transition-colors ${
              active
                ? "bg-amber-500/90 text-black"
                : "text-slate-400 hover:text-amber-300"
            }`}
            title={`${label} · ${hint}`}
          >
            <Icon className="h-3 w-3" />
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default ModelPicker;
